import { normalizeMap } from '../lib'
import overlayOptionProp from './overlayOptionProp'

export default function (props) {
  const res = {}
  normalizeMap(props).forEach(({key, val}) => {
    res[key] = overlayOptionProp(key, val)
  })
  return res
}



// WEBPACK FOOTER //
// ./src/utils/mapOverlayOptions.js